import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { QuoteWizard } from '../components/QuoteWizard';
import { motion } from 'framer-motion';
import { Phone, Clock, ShieldCheck } from 'lucide-react';

export default function QuotePage() {
  return (
    <div className="min-h-screen bg-white" data-testid="quote-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-navy-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }} />
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white uppercase"
          >
            Request a <span className="text-orange-500">Quote</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="mt-4 text-base lg:text-lg text-slate-400 font-body max-w-2xl mx-auto"
          >
            Tell us about your freight and a specialist will follow up with competitive pricing.
          </motion.p>
        </div>
      </section>

      {/* Quote Form Section */}
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-12">
            {/* Form */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-xl border border-slate-200 p-8 lg:p-10 shadow-sm">
                <QuoteWizard />
              </div>
            </div>

            {/* Sidebar */}
            <div className="space-y-6">
              {/* Contact Card */}
              <div className="bg-navy-900 rounded-xl p-6">
                <h3 className="font-heading text-xl font-bold text-white uppercase mb-4">
                  Prefer to Talk?
                </h3>
                <p className="font-body text-slate-400 text-sm mb-6">
                  Our freight specialists are available to discuss your shipping needs.
                </p>
                <a
                  href="tel:+18888984591"
                  className="flex items-center gap-3 text-orange-500 font-body font-semibold hover:text-orange-400 transition-colors duration-200"
                >
                  <Phone className="w-5 h-5" />
                  (888) 898-4591
                </a>
                <div className="mt-4 pt-4 border-t border-navy-700">
                  <p className="font-body text-sm text-slate-400">
                    <span className="text-white font-medium">Email:</span>{' '}
                    <a href="mailto:info@summitmoves.com" className="text-orange-500 hover:text-orange-400">
                      info@summitmoves.com
                    </a>
                  </p>
                </div>
              </div>

              {/* Features */}
              <div className="bg-slate-50 rounded-xl p-6 space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-orange-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock className="w-5 h-5 text-orange-500" />
                  </div>
                  <div>
                    <h4 className="font-body font-semibold text-navy-900">Fast Response</h4>
                    <p className="font-body text-sm text-slate-600">
                      Quotes typically delivered within hours
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-orange-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <ShieldCheck className="w-5 h-5 text-orange-500" />
                  </div>
                  <div>
                    <h4 className="font-body font-semibold text-navy-900">No Obligation</h4>
                    <p className="font-body text-sm text-slate-600">
                      Free quotes with no pressure to book
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
